








import { Component, Vue, Watch } from "vue-property-decorator";
import PeekingParrot from "@/assets/images/parrot/PeekingParrot.svg?inline";

@Component({
  components: {
    PeekingParrot
  }
})
export default class PreAssessmentRecord extends Vue {

    private gotoNext() {
      this.$emit("gotoNext");  
    }
}
